import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core';

var useStyles = makeStyles(function (theme) {
  return {
    streamlineIcon: {
      color: theme.palette.grey[400],
      fill: "currentColor",
      stroke: "currentColor",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fontSize: theme.spacing(3),
      flexShrink: 0,
      userSelect: "none",
      "& svg path": {
        stroke: "currentColor"
      }
    }
  };
});
var StreamlineIcon = function StreamlineIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    size = _ref.size,
    className = _ref.className,
    e2eId = _ref.e2eId,
    onClick = _ref.onClick,
    children = _ref.children;
  var initialWidth = 24;
  var initialHeight = 24;
  var classes = useStyles();
  var getClassName = function getClassName() {
    var classNames = [classes.streamlineIcon];
    if (className) {
      classNames.push(className);
    }
    return classNames.join(" ");
  };
  var resizeWidth = 1;
  var resizeHeight = 1;
  if (size) {
    resizeWidth = size / initialWidth;
    resizeHeight = size / initialHeight;
  } else {
    if (width && width !== initialWidth) {
      resizeWidth = initialWidth / width;
    }
    if (height && height !== initialHeight) {
      resizeHeight = initialHeight / height;
    }
  }
  return /*#__PURE__*/React__default.createElement("i", {
    className: getClassName(),
    onClick: onClick,
    "e2e-id": e2eId
  }, children && (resizeWidth !== 1 || resizeHeight !== 1) ? /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 ".concat(resizeWidth * initialWidth, " ").concat(resizeHeight * initialHeight),
    width: resizeWidth * initialWidth,
    height: resizeHeight * initialHeight
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "scale(".concat(resizeWidth, ",").concat(resizeHeight, ")")
  }, children)) : /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 ".concat(initialWidth, " ").concat(initialHeight)
  }, children));
};
StreamlineIcon.defaultProps = {};
StreamlineIcon.propTypes = {
  size: PropTypes__default.number,
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  className: PropTypes__default.string,
  e2eId: PropTypes__default.string,
  onClick: PropTypes__default.func,
  children: PropTypes__default.element
};

export { StreamlineIcon as default };
//# sourceMappingURL=StreamlineIcon.js.map
